module.exports = __webpack_public_path__ + "media/application/images/preview-twitter-card-847cd45454887570d18269226d96e562.png";